export default __webpack_public_path__ + "static/media/452.a3fb1ba6.png";